import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { List, Box, Chip } from "@mui/material";
import { AssetFilterOptions } from "@config/client/filter-options";
import { FilterListItem } from "./filter-list-item";
import { FilterLoader } from "./filter-loader";
import { FilterEmpty } from "./filter-empty";
import useAssetStore from "@stores/client/useAssetStore";
import { useInfiniteScroll } from "@hooks/shared/use-infinite-scroll";

export const AssetFilterView = () => {
  const {
    assetFilterData,
    fetchingFilterData,
    fetchingMoreFilterData,
    filterConfig,
    currentFilter,
    handleAssetFilterClose,
    setFilterPage,
  } = useAssetStore();

  const { t } = useTranslation();
  const [filterState, setFilterState] = useState(null);
  const { sentinelRef } = useInfiniteScroll(
    filterConfig,
    setFilterPage,
    fetchingMoreFilterData,
  );

  useEffect(() => {
    if (currentFilter) {
      const currentFilterState = AssetFilterOptions.find(
        (option) => option.key === currentFilter,
      );
      setFilterState(currentFilterState || null);
      return;
    }

    setFilterState(null);
  }, [currentFilter]);

  return (
    <Box sx={{ marginTop: 2 }}>
      <Chip
        variant="outlined"
        label={
          <span data-testid="asset-filter-title">
            {filterState ? t(filterState.name) : t("assets.noFilter")}
          </span>
        }
        onDelete={handleAssetFilterClose}
        sx={{ maxWidth: 230 }}
      />
      {fetchingFilterData && <FilterLoader />}
      {!fetchingFilterData && assetFilterData && assetFilterData.length > 0 && (
        <List sx={{ mt: 1, ml: 1 }}>
          {assetFilterData.map((item) => (
            <FilterListItem key={item.path} item={item} />
          ))}
          {filterConfig?.page + 1 < filterConfig?.pages && (
            <Box ref={sentinelRef} sx={{ height: 1 }} />
          )}
        </List>
      )}
      {fetchingMoreFilterData && (
        <Box sx={{ mt: 1, ml: 2 }}>
          <FilterLoader />
        </Box>
      )}
      {!fetchingFilterData &&
        (!assetFilterData || assetFilterData.length === 0) && <FilterEmpty />}
    </Box>
  );
};
